import { useCallback, useEffect, useRef } from 'react'

export default () => {
  const mountedRef = useRef(false)

  useEffect(() => {
    mountedRef.current = true

    return () => {
      // The cleanup function of useEffect is called by React on unmount
      mountedRef.current = false
    }
  }, [])

  return useCallback(() => mountedRef.current, [])
}